import React from 'react';
import DayCell from './DayCell';

const DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function ymd(date) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
}

function addDays(date, days) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
}

function sameDay(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

const CalendarGrid = ({
    weeks,
    mode,
    viewYear,
    viewMonth,
    today,
    eventsByDay,
    onOpen,
}) => {
    const rangeKey = weeks.length ? `${ymd(weeks[0])}-${mode}` : '';

    return (
        <div className="fc-month-wrap">
            <div
                className="fc-month"
                role="grid"
                aria-label={mode === 'week' ? 'Week calendar' : 'Month calendar'}
                key={rangeKey}
            >
                {weeks.map((weekStart, weekIndex) => (
                    <div className="fc-week" role="row" key={ymd(weekStart)}>
                        {Array.from({ length: 7 }, (_, index) => {
                            const day = addDays(weekStart, index);
                            const key = ymd(day);
                            const events = eventsByDay.get(key) || [];
                            const isOut = mode === 'month' && (day.getFullYear() !== viewYear || day.getMonth() !== viewMonth);
                            const isToday = sameDay(day, today);
                            const isMonthStart = day.getDate() === 1;
                            const dateLabel = isMonthStart ? `${MON[day.getMonth()]} ${day.getDate()}` : String(day.getDate());
                            const fullDate = `${MONTHS[day.getMonth()]} ${day.getDate()}, ${day.getFullYear()}`;
                            return (
                                <DayCell
                                    key={key}
                                    dowLabel={weekIndex === 0 ? DOW[day.getDay()] : null}
                                    dateLabel={dateLabel}
                                    ariaLabel={`${fullDate}, ${events.length} ${events.length === 1 ? 'event' : 'events'}`}
                                    isOut={isOut}
                                    isToday={isToday}
                                    isMonthStart={isMonthStart}
                                    events={events}
                                    onOpen={onOpen}
                                />
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CalendarGrid;
